import script from "./AccordionGroupModule.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionGroupModule.vue?vue&type=script&setup=true&lang=js"

import "./AccordionGroupModule.vue?vue&type=style&index=0&id=61e82634&lang=scss"

const __exports__ = script;

export default __exports__